import * as cfpmServices from '../services';

export default {
  namespace: 'tvf',

  state: {
    fieldList: [],
    searchValue: { variableType: 'TEMPORARY' },
  },

  effects: {
    //设置查询的参数
    *setSearchValue({ payload: { values } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          searchValue: { variableType: 'TEMPORARY', ...values },
        },
      });
    },
    //查询字段集合
    *getFieldList({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(cfpmServices.getFieldList, values);
      yield put({
        type: 'save',
        payload: {
          fieldList: response || [],
        },
      });
    },
    //新增 字段集合
    *addField({ payload: values, callback }, { call }) {
      const { data: response } = yield call(cfpmServices.addField, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //编辑 字段集合
    *editField({ payload: values, callback }, { call }) {
      const { data: response } = yield call(cfpmServices.editField, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //删除 字段集合
    *deleteField({ payload: { id }, callback }, { call }) {
      const { data: response } = yield call(cfpmServices.deleteField, id);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
